
























import { Component, Vue } from 'vue-property-decorator';
import MyDialog from './components/MyDialog.vue';

@Component({
  components: {
    MyDialog,
  },
})
export default class App extends Vue {
  public isDialogShown = false

  handleClose(elm: HTMLElement | null) {
    this.isDialogShown = false
    if (elm !== null) {
      elm.focus()
    }
  }

  handleOk(elm: HTMLElement | null) {
    this.isDialogShown = false
    if (elm !== null) {
      elm.focus()
    }
  }
}
